module.exports = __webpack_public_path__ + "img/edit-alt-2.148f7e8f.svg";